export function Hero() {
  return (
    <section
      style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        paddingTop: '72px',
        background:
          'linear-gradient(160deg, #EFF6FF 0%, #F8FAFF 45%, #F5F0FF 100%)',
      }}
    >
      {/* Soft mesh background */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
        <div
          style={{
            position: 'absolute',
            top: '-100px',
            left: '-100px',
            width: '600px',
            height: '600px',
            borderRadius: '50%',
            background:
              'radial-gradient(circle, rgba(59,130,246,0.1) 0%, transparent 70%)',
            filter: 'blur(60px)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '-40px',
            right: '-80px',
            width: '500px',
            height: '500px',
            borderRadius: '50%',
            background:
              'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)',
            filter: 'blur(60px)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '35%',
            left: '45%',
            width: '350px',
            height: '350px',
            borderRadius: '50%',
            background:
              'radial-gradient(circle, rgba(139,92,246,0.06) 0%, transparent 70%)',
            filter: 'blur(40px)',
          }}
        />
        {/* Dot grid */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage:
              'radial-gradient(circle, rgba(59,130,246,0.1) 1px, transparent 1px)',
            backgroundSize: '32px 32px',
          }}
        />
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '80px 24px',
          width: '100%',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '60px',
          alignItems: 'center',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Left content */}
        <div style={{ animation: 'fadeSlideUp 0.8s ease forwards' }}>
          {/* Badge */}
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: 'rgba(59,130,246,0.08)',
              border: '1px solid rgba(59,130,246,0.2)',
              borderRadius: '100px',
              padding: '6px 16px',
              marginBottom: '28px',
            }}
          >
            <span
              style={{
                width: '7px',
                height: '7px',
                borderRadius: '50%',
                background: '#3B82F6',
                boxShadow: '0 0 8px rgba(59,130,246,0.7)',
                display: 'inline-block',
                flexShrink: 0,
              }}
            />
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '0.3px',
                color: '#2563EB',
                fontWeight: '600',
              }}
            >
              Trusted by 500,000+ users worldwide
            </span>
          </div>

          {/* Headline */}
          <h1
            style={{
              fontSize: 'clamp(38px, 5vw, 66px)',
              fontWeight: '800',
              lineHeight: '1.08',
              letterSpacing: '-2px',
              color: '#0F172A',
              margin: '0 0 24px',
            }}
          >
            Get Verified <br />
            <span
              style={{
                background:
                  'linear-gradient(135deg, #3B82F6 0%, #6366F1 50%, #8B5CF6 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Anywhere
            </span>{' '}
            in Seconds
          </h1>

          {/* Subheadline */}
          <p
            style={{
              fontSize: 'clamp(16px, 2vw, 19px)',
              fontWeight: '400',
              lineHeight: '1.7',
              color: '#6B7280',
              margin: '0 0 40px',
              maxWidth: '480px',
            }}
          >
            Instant OTP delivery via virtual phone numbers from 150+ countries.
            Protect your privacy and verify on any platform — no SIM card
            needed.
          </p>

          {/* CTAs */}
          <div
            style={{
              display: 'flex',
              gap: '14px',
              flexWrap: 'wrap',
              marginBottom: '56px',
            }}
          >
            <a
              href="#country-pricing"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: 'linear-gradient(135deg, #3B82F6, #6366F1)',
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '600',
                padding: '16px 32px',
                borderRadius: '12px',
                transition: 'all 0.3s ease',
                boxShadow: '0 8px 24px rgba(59,130,246,0.35)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow =
                  '0 16px 36px rgba(59,130,246,0.45)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow =
                  '0 8px 24px rgba(59,130,246,0.35)'
              }}
            >
              Get a Number Free
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a
              href="#how-it-works"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: 'white',
                border: '1.5px solid #E5E7EB',
                color: '#374151',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '500',
                padding: '16px 32px',
                borderRadius: '12px',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#3B82F6'
                e.currentTarget.style.color = '#3B82F6'
                e.currentTarget.style.boxShadow =
                  '0 4px 16px rgba(59,130,246,0.12)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#E5E7EB'
                e.currentTarget.style.color = '#374151'
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <polygon points="5,3 19,12 5,21" fill="currentColor" />
              </svg>
              See How It Works
            </a>
          </div>

          {/* Trust stats */}
          <div
            style={{
              display: 'inline-flex',
              background: 'white',
              border: '1px solid #E5E7EB',
              borderRadius: '16px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
              overflow: 'hidden',
              flexWrap: 'wrap',
            }}
          >
            {[
              { value: '500K+', label: 'Users' },
              { value: '150+', label: 'Countries' },
              { value: '99.8%', label: 'Delivery Rate' },
              { value: '< 3s', label: 'Avg. OTP Time' },
            ].map((stat, i) => (
              <div
                key={stat.label}
                style={{
                  padding: '16px 24px',
                  borderRight: i < 3 ? '1px solid #F3F4F6' : 'none',
                  animation: `fadeSlideUp ${0.9 + i * 0.1}s ease forwards`,
                }}
              >
                <div
                  style={{
                    fontSize: '22px',
                    fontWeight: '800',
                    color: '#0F172A',
                    letterSpacing: '-0.5px',
                  }}
                >
                  {stat.value}
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    color: '#9CA3AF',
                    marginTop: '2px',
                    fontWeight: '500',
                  }}
                >
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Phone Mockup */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            animation: 'floatPhone 4s ease-in-out infinite',
          }}
        >
          <PhoneMockup />
        </div>
      </div>

      <style>{`
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes floatPhone {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-14px); }
        }
        @keyframes slideInNotif {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  )
}

function PhoneMockup() {
  return (
    <div style={{ position: 'relative', width: '280px' }}>
      {/* Bottom shadow glow */}
      <div
        style={{
          position: 'absolute',
          bottom: '-30px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '200px',
          height: '40px',
          background: 'rgba(59,130,246,0.18)',
          filter: 'blur(24px)',
          borderRadius: '50%',
        }}
      />

      {/* Phone frame */}
      <div
        style={{
          width: '280px',
          height: '560px',
          background: 'linear-gradient(160deg, #FFFFFF, #F8FAFF)',
          borderRadius: '44px',
          border: '1.5px solid #E2E8F0',
          padding: '16px',
          boxShadow:
            '0 32px 80px rgba(59,130,246,0.14), 0 8px 24px rgba(0,0,0,0.07), inset 0 1px 0 rgba(255,255,255,1)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Notch */}
        <div
          style={{
            width: '100px',
            height: '28px',
            background: '#F1F5F9',
            borderRadius: '0 0 20px 20px',
            margin: '0 auto 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          <div
            style={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              background: '#CBD5E1',
            }}
          />
          <div
            style={{
              width: '36px',
              height: '6px',
              borderRadius: '4px',
              background: '#CBD5E1',
            }}
          />
        </div>

        {/* Screen content */}
        <div style={{ padding: '0 4px' }}>
          <div
            style={{
              textAlign: 'center',
              fontSize: '36px',
              fontWeight: '300',
              color: '#0F172A',
              marginBottom: '4px',
            }}
          >
            9:41
          </div>
          <div
            style={{
              textAlign: 'center',
              fontSize: '13px',
              color: '#94A3B8',
              marginBottom: '20px',
            }}
          >
            Monday, Jan 15
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '24px',
            }}
          >
            <div
              style={{
                width: '52px',
                height: '52px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #EFF6FF, #EDE9FE)',
                border: '1.5px solid #BFDBFE',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(59,130,246,0.12)',
              }}
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#3B82F6"
                strokeWidth="2"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </div>
          </div>

          {/* SMS notification */}
          <div
            style={{
              background: 'white',
              border: '1px solid #E5E7EB',
              borderRadius: '16px',
              padding: '14px',
              marginBottom: '10px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
              animation: 'slideInNotif 1s ease 0.3s both',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '8px',
              }}
            >
              <div
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, #3B82F6, #6366F1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  boxShadow: '0 2px 8px rgba(59,130,246,0.3)',
                }}
              >
                💬
              </div>
              <div>
                <div
                  style={{
                    fontSize: '12px',
                    fontWeight: '700',
                    color: '#111827',
                  }}
                >
                  Messages
                </div>
                <div style={{ fontSize: '11px', color: '#9CA3AF' }}>now</div>
              </div>
            </div>
            <div
              style={{ fontSize: '13px', color: '#6B7280', lineHeight: '1.5' }}
            >
              Your GetCode verification code is:
            </div>
            <div
              style={{
                fontSize: '28px',
                fontWeight: '800',
                letterSpacing: '8px',
                background: 'linear-gradient(135deg, #3B82F6, #6366F1)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                margin: '8px 0 4px',
                textAlign: 'center',
              }}
            >
              847 261
            </div>
            <div
              style={{
                fontSize: '11px',
                color: '#9CA3AF',
                textAlign: 'center',
              }}
            >
              Valid for 10 minutes
            </div>
          </div>

          {/* Success notification */}
          <div
            style={{
              background: '#F0FDF4',
              border: '1px solid #BBF7D0',
              borderRadius: '16px',
              padding: '12px 14px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              animation: 'slideInNotif 1s ease 0.6s both',
            }}
          >
            <span style={{ fontSize: '20px' }}>✅</span>
            <div>
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: '700',
                  color: '#15803D',
                }}
              >
                Verified Successfully
              </div>
              <div style={{ fontSize: '11px', color: '#6B7280' }}>
                +1 (555) 847-2610 · GetCode
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Side button */}
      <div
        style={{
          position: 'absolute',
          right: '-3px',
          top: '120px',
          width: '3px',
          height: '60px',
          background: '#CBD5E1',
          borderRadius: '0 2px 2px 0',
        }}
      />
    </div>
  )
}
